import React from 'react'
import { Link } from 'react-router-dom'
import pluralize from 'pluralize'
import './create-button.css'
import { ReactComponent as Icon } from './add.svg'

export const CreateButtonVisual = () => (
  <span className="add-btn" title="Добавить запись">
    <Icon />
  </span>
)

const CreateButton = ({ config }) => (
  <Link
    to={`/${pluralize.singular(config.entityName)}/create`}
    className="action"
  >
    <CreateButtonVisual />
  </Link>
)

export default CreateButton
